import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3v18h18","key":"svg-0"}],["path",{"d":"M3 6h18","key":"svg-1"}],["path",{"d":"M3 8c10 0 8 9 18 9","key":"svg-2"}]]

/**
 * IconChartSankey
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hhcnQtc2Fua2V5Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDN2MThoMTgiIC8+CiAgPHBhdGggZD0iTTMgNmgxOCIgLz4KICA8cGF0aCBkPSJNMyA4YzEwIDAgOCA5IDE4IDkiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/chart-sankey
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChartSankey = createReactComponent('outline', 'chart-sankey', 'ChartSankey', __iconNode);

export default IconChartSankey;